import { Component, Output } from '@angular/core';
import { User } from './user/user';
import { Router, RouterOutlet, ActivatedRoute, UrlHandlingStrategy } from '@angular/router';
import { Authenticate } from './authenticate/authenticate';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserService } from './_services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  public logged = false;
  returnUrl = "/login";
  route: ActivatedRoute;
  title = 'TikToc';
  currentUser: User;
  auth: Authenticate;
  loggedin: boolean = false;
  propsToShow = ['userAgent', 'os', 'browser', 'device', 'os_version', 'browser_version'];
  deviceInfo = null;
  constructor(private router: Router,
    private deviceService: DeviceDetectorService, private rt: ActivatedRoute,
    private userService: UserService) {
    this.deviceInfo = deviceService.getDeviceInfo();
  }

  ngOnInit() {
    if (!this.getCurrentUser())
      this.nextPage();
  }

  getCurrentUser() {
    try {
      this.auth = JSON.parse(localStorage.getItem('currentUser'));
      if (this.auth != null) {
        this.currentUser = this.userService.getCurrentUserFromCookie();
      }
      else
        this.currentUser = null;
      return false;
    }
    catch (e) {
      console.log("we caught an error!!" + e);
      return false;
    }
  }

  nextPage() {
    this.router.navigate([this.returnUrl]);
  }
  updateUser() {
    this.getCurrentUser();
  }
  public getLogged(): boolean {
    return this.logged;
  }

  get isMobile() {
    return this.deviceService.isMobile();
  }

  get isTablet() {
    return this.deviceService.isTablet();
  }

  get isDesktop() {
    return this.deviceService.isDesktop();
  }


}
